<template>
  <div id="imprimir-contrato" class="vs-con-loading__container">
    <div v-if="desconto.id">
      <section
        class="sheet padding-15mm"
        style="background-image: url(); background-size: contain;"
      >
        <table class="header">
          <tbody>
            <tr>
              <td align="left">
                <img :src="$whitelabel.logo_png_black" style="height: 2cm;" />
              </td>
              <td>
                <h2>REDE IBERO AMERICANA DE ASSOCIAÇÕES DE IDOSOS DO BRASIL - RIAAM</h2>
              </td>
              <td align="right">
                <img :src="$whitelabel.logo_riaam" style="height: 2cm;" />
              </td>
            </tr>
          </tbody>
        </table>

        <div style="height: 10px;"></div>

        <table style="padding-left: 0px;">
          <tbody>
            <tr>
              <td colspan="12" style="padding-bottom: 30">
                Entidade:
                <u>
                  ASSOCIAÇÃO AOS BENEFICIARIOS DO REGIME GERAL DA PREVIDENCIA, SERVIDOR PUBLICO E AFINS BRASIL
                  VANTAGENS
                </u>
              </td>
            </tr>
            <tr>
              <td colspan="6">
                CNPJ:
                <u>29.563.662/0001-51</u>
              </td>
              <td colspan="6">
                Data de Fundação:
                <u>22/01/2018</u>
              </td>
            </tr>
            <tr>
              <td colspan="12">
                Endereço:
                <u>RUA TREZE DE MAIO, 2469</u>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                Bairro:
                <u>VILA CIDADE</u>
              </td>
              <td colspan="3">
                Município:
                <u>CAMPO GRANDE</u>
              </td>
              <td colspan="3">
                UF:
                <u>MS</u>
              </td>
              <td></td>
            </tr>
            <tr>
              <td colspan="3">
                CEP:
                <u>79002-351</u>
              </td>
              <td colspan="3">
                Telefone:
                <u>0800 609 1234</u>
              </td>
              <td colspan="3">Fax</td>
              <td></td>
            </tr>
            <tr>
              <td>E-mail</td>
            </tr>
            <tr></tr>
            <tr></tr>
            <tr></tr>
            <tr></tr>
          </tbody>
        </table>

        <div style="height: 10px;"></div>

        <table class="gray">
          <tr class="head">
            <td align="center" colspan="2">
              <h2>
                <u>
                  <b>AUTORIZAÇÃO</b>
                </u>
              </h2>
            </td>
          </tr>
        </table>
        <div style="height: 10px;">
          Código de Verificação:
          <strong>{{ desconto.codigo }}</strong>
        </div>
        <div style="height: 10px;"></div>

        <p class="line-height">
          Eu,
          <span>{{ cliente.nome }}</span>, CPF/MF
          <span>{{ cliente.cpf }}</span>, brasileiro(a), nascido(a) na
          data
          <span>{{ cliente.data_nascimento }}</span>
          , beneficiário(a) do Regime Geral da Previdência Social,
          <template
            v-if="enderecoCliente.id"
          >
            residente e domiciliado(a) à
            <span>{{ enderecoCliente.endereco }}, {{ enderecoCliente.numero }}, {{ enderecoCliente.bairro }}</span>
            Município:
            <span>{{ enderecoCliente.cidade.nome }}</span>
            Estado:
            <span>{{ enderecoCliente.estado.uf }}</span>,
            CEP:
            <span>{{ enderecoCliente.cep }}</span>,
          </template>
          portador(a) do Benefício nº
          <span>{{ desconto.beneficio.beneficio }}</span> Espécie:
          <span>{{ desconto.beneficio.especieBeneficio.codigo }}-{{ desconto.beneficio.especieBeneficio.descricao }}</span>, sócio da
          <span>BRASIL VANTAGENS</span>, sob o
          número
          <span class="width-70-vazio"></span>,
          <b>AUTORIZO</b> o mesmo a promover perante o Instituto Nacional de Seguro Social - INSS, através da
          <b>
            REDE
            IBERO-AMERICANA DE ASSOCIAÇÕES DE IDOSOS DO BRASIL – RIAAM
          </b>, o desconto da mensalidade de associado à
          entidade estadual e municipal vinculada
          à
          <b>RIAAM</b>, correspondente a
          <span>{{ desconto.porcentagemDesconto.porcentagem }}</span>%
          do valor mensal do benefício previdenciário, a partir da competência
          <span>{{ $plugins.moment(desconto.created_at).add(1, 'months').format('MM/YYYY') }}</span>,
          com respaldo no disposto no Inciso V do Artigo 115 da Lei
          8.213 de 24 de julho de 1991.
        </p>

        <table class="gray">
          <tr></tr>
          <tr>
            <td align="center" class="font-minimal" style="padding-bottom: 18px">
              <span
                v-if="enderecoCliente.id"
              >{{ enderecoCliente.cidade.nome }} - {{ enderecoCliente.estado.uf }}</span>,
              <span>{{ desconto.created_at | formatarData }}</span>
            </td>
          </tr>
        </table>
        <div style="height: 20px;"></div>

        <table class="gray">
          <tr>
            <td colspan="6">
              <p class="text-center" align="center">
                <span class="width-300"></span>
                Assinatura ou impressão digital do titular
                <br />do benefício previdenciário
              </p>
            </td>
            <td colspan="6">
              <p class="text-center" align="center">
                <span class="width-300"></span>
                Assinatura do Presidente da entidade
                <br />vinculada à RIAAM-BRASIL
              </p>
            </td>
          </tr>
        </table>
        <div style="height: 20px;"></div>

        <p style="padding-left: 60px; padding-right: 60px;">
          Ciente e de acordo com as informações do associado à entidade
          estadual e municipal vinculada à
          <b>REDE IBERO-AMERICANA DE ASSOSICAÇÕES DE IDOSOS DO BRASIL - RIAAM</b>, e com os
          poderes a nós conferidos para o desconto pretendido.
        </p>

        <div style="height: 200px;"></div>

        <table class="gray">
          <tr>
            <td colspan="12">
              <p class="text-center" align="center">
                <span class="width-400"></span>
                <br />Assinatura do Presidente ou representante legal da
                <b>ACORDANTE</b>
              </p>
            </td>
          </tr>
        </table>
        <div style="height: 20px;"></div>
      </section>

      <section class="sheet padding-10mm" style="padding-top: 25%">
        <div id="container_2">
          <h1 style="font-size: 30px; text-align: center;">Código de Verificação:</h1>
          <h1 style="font-size: 170px; text-align: center;">{{ desconto.codigo }}</h1>
          <p style="text-align: center;">
            <qrcode :value="desconto.codigo" :options="{ width: 100 }"></qrcode>
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import queryParams from "@services/repository-service";
import api from "@services/api-service";

export default {
  name: "botao-imprimir-contrato",
  data() {
    return {
      desconto: {
        beneficio: {}
      },
      cliente: {},
      enderecos: [{}],
      telefones: [{}],
      situacao: {},
      anexos: {},
      loading: false
    };
  },
  mounted() {
    setTimeout(this.buscarDesconto, 100);
  },
  watch: {
    loading(loading) {
      const appLoading = document.getElementById("loading-bg");
      if (appLoading) {
        appLoading.style.display = loading ? "visible" : "none";
      }
    }
  },
  computed: {
    telefonesCliente() {
      return this.telefones.map(t => t.formatado).join(" | ");
    },
    enderecoCliente() {
      return this.enderecos[0];
    }
  },
  methods: {
    async buscarDesconto() {
      this.loading = true;
      try {
        const response = await api().get(`contratos/${this.$route.params.id}`, {
          params: queryParams({
            relationships: [
              "porcentagemDesconto",
              "beneficio.especieBeneficio",
              "cliente",
              "cliente.sexo",
              "cliente.estadoCivil",
              "cliente.enderecos",
              "cliente.enderecos.estado",
              "cliente.telefones"
            ]
          })
        });

        if (response.data.status) {
          this.desconto = response.data.data;
          this.cliente = this.desconto.cliente;
          this.situacao = {
            id: this.desconto.id,
            status: this.desconto.status,
            statusMotivo: this.desconto.statusMotivo
          };
          this.anexos = {
            id: this.desconto.id,
            anexos: []
          };

          if (this.cliente.enderecos.length > 0) {
            this.enderecos = this.cliente.enderecos;
          }

          if (this.cliente.telefones.length > 0) {
            this.telefones = this.cliente.telefones;
          }
        }
      } catch (error) {
        this.$router.replace({ name: "error-404" });
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="css" scoped>
@import url("https://cdnjs.cloudflare.com/ajax/libs/normalize/7.0.0/normalize.min.css");
@import url("https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.4.1/paper.min.css");
@page {
  size: A4;
}

.sheet {
  font-size: 10pt;
  font-family: "Calibri", sans-serif;
  line-height: 5mm;
  text-align: justify;
  color: #000;
}
body {
  font-size: 9pt;
  font-family: "Arial", serif;
  line-height: 5mm;
  text-align: justify;
}

b {
  font-weight: 700;
}

h1 {
  font-family: "Arial", serif;
  font-size: 13pt;
  margin: 0;
}

h2 {
  font-family: "Arial", serif;
  font-size: 9pt;
  margin: 0;
  background: transparent;
}

small {
  line-height: 4mm;
}

table {
  border-spacing: 0;
}

table.header > tbody > tr > td {
  padding: 10px;
}

table.gray {
  align-content: center;
  /*background-color: #ffffff;*/
}

table.dadosBancarios {
  background-color: #ffffff;
}

table.dadosBancarios tbody > tr > td {
  padding: 0 2mm;
}

table.dadosBancarios tbody > tr > td > b {
  font-size: 90%;
}

td.font-minimal {
  font-family: "Arial", serif;
  font-size: 8pt;
  line-height: 4mm;
  padding: 2mm;
}

td.assinatura {
  padding-top: 20px;
}

td.info {
  font-family: "Arial", serif;
  font-size: 7pt;
  line-height: 3mm;
  font-weight: bold;
}

span {
  font-family: "Cousine", monospace;
  display: inline-block;
  border-bottom: 1px solid black;
  line-height: 0px;
  padding: 0 5px 6px 5px;
  font-size: 10pt;
}

span.width-150 {
  width: 150px;
  height: 10pt;
}

span.width-70-vazio {
  width: 70px;
  height: 10pt;
  margin-bottom: -3pt !important;
}

span.width-50 {
  width: 50px;
  height: 9pt;
}

span.width-250 {
  width: 250px;
}

span.width-400 {
  width: 400px;
}

span.width-300 {
  width: 300px;
}

table {
  width: 100%;
}

.table-bordered {
  width: 100%;
  /*border: 1px solid #b9b9b9;*/
}

.table-bordered th,
.table-bordered td {
  border-bottom: 1px solid #b9b9b9;
}

.img-responsive {
  width: 40%;
  display: inline-block;
}

.item {
  font-size: 10px;
  font-weight: bold;
  line-height: 13px;
}

.cousine {
  font-family: "Cousine", monospace !important;
  border: none;
  font-size: 12px;
  padding: 0;
}

.line-height {
  line-height: 25px;
}

input.data-contrato {
  font-family: "Cousine", monospace;
  display: inline-block;
  border: none;
  line-height: 0px;
  outline: none;
  font-size: 8pt;
  width: 120px;
  margin-bottom: -6px;
  text-align: center;
  background-color: transparent;
}

input.data-nome {
  font-family: "Cousine", monospace;
  display: inline-block;
  border: none;
  line-height: 0px;
  border-bottom: none;
  font-size: 8pt;
  width: 400px;
  text-align: center;
  background-color: transparent;
}

input.data {
  font-family: "Cousine", monospace;
  display: inline-block;
  border: none;
  line-height: 0px;
  border-bottom: none;
  font-size: 12px;
  text-align: left;
  background-color: transparent;
}

input.data-200 {
  font-family: "Cousine", monospace;
  display: inline-block;
  border: none;
  line-height: 0px;
  border-bottom: none;
  width: 200px;
  font-size: 12px;
  text-align: left;
  background-color: transparent;
}

input.data-400 {
  font-family: "Cousine", monospace;
  display: inline-block;
  border: none;
  line-height: 0px;
  border-bottom: none;
  width: 400px;
  font-size: 12px;
  text-align: left;
  background-color: transparent;
}

input.data-250 {
  font-family: "Cousine", monospace;
  display: inline-block;
  border: none;
  line-height: 0px;
  border-bottom: none;
  width: 250px;
  font-size: 12px;
  text-align: left;
  background-color: transparent;
}

input.data-325 {
  font-family: "Cousine", monospace;
  display: inline-block;
  border: none;
  line-height: 0px;
  border-bottom: none;
  width: 325px;
  font-size: 12px;
  text-align: left;
  background-color: transparent;
}

input.data-100 {
  font-family: "Cousine", monospace;
  display: inline-block;
  border: none;
  line-height: 0px;
  border-bottom: none;
  width: 100px;
  font-size: 12px;
  text-align: left;
  background-color: transparent;
}

input.data-110 {
  font-family: "Cousine", monospace;
  display: inline-block;
  border: none;
  line-height: 0px;
  border-bottom: none;
  width: 110px;
  font-size: 12px;
  text-align: left;
  background-color: transparent;
}

input.data-50 {
  font-family: "Cousine", monospace;
  display: inline-block;
  border: none;
  line-height: 0px;
  border-bottom: none;
  width: 100px;
  font-size: 12px;
  text-align: left;
  background-color: transparent;
}

input.data-45 {
  font-family: "Cousine", monospace;
  display: inline-block;
  border: none;
  line-height: 0px;
  border-bottom: none;
  width: 45px;
  font-size: 12px;
  text-align: left;
  background-color: transparent;
}

input.field {
  display: inline-block;
  border: none;
  outline: none;
  border-bottom: none;
  margin-bottom: -6px;
  background-color: transparent;
}

#container_2 {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
</style>
